import {
  getPtoForGood,
  createPtoForGood,
  updatePtoForGood,
  deletePtoForGood,
  getPtoForGoodOne,
  deletePtoForGoodImages,
  getExcelFileReportOne
} from '@/api/pto'


import {
  getStatusMini
} from '@/api/reference'


export default {


  FETCH_REPORT_EXCEL_ONE: ({ commit }, id) => new Promise((resolve, reject) => {
    getExcelFileReportOne(id)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),


  FETCH_PTO_FOR_GOOD_LIST: ({ commit }, params) => new Promise((resolve, reject) => {
    getPtoForGood(params)
      .then(response => {
        commit('SET_PTO_FOR_GOOD_LIST', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  FETCH_PTO_FOR_GOOD_ONE: ({ commit }, id) => new Promise((resolve, reject) => {
    getPtoForGoodOne(id)
      .then(response => {
        commit('SET_PTO_FOR_GOOD_ONE', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  FETCH_KNOWLEDGE_BASE_STATUSES_MINI: ({ commit },) => new Promise((resolve, reject) => {
    getStatusMini()
      .then(response => {
        commit('SET_KNOWLEDGE_BASE_STATUSES_MINI', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  CREATE_PTO_FOR_GOOD: (_, data) => createPtoForGood(data),
  UPDATE_PTO_FOR_GOOD: (_, data) => updatePtoForGood(data),
  DELETE_PTO_FOR_GOOD: (_, id) => deletePtoForGood(id),
  DELETE_PTO_FOR_GOOD_IMAGE: (_, id) => deletePtoForGoodImages(id),
}
